import { Phone } from "lucide-react";

export const LINES = [
  { name: "Emergency", num: "000", tel: "000", note: "If you or someone else is in immediate danger" },
  { name: "13YARN", num: "13 92 76", tel: "139276", note: "24/7 crisis support by Aboriginal & Torres Strait Islander people" },
  { name: "Lifeline", num: "13 11 14", tel: "131114", note: "24/7 crisis support and suicide prevention" },
  { name: "1800RESPECT", num: "1800 737 732", tel: "1800737732", note: "Domestic, family & sexual violence support" },
  { name: "NSW DV Line", num: "1800 65 64 63", tel: "1800656463", note: "24/7 NSW Domestic Violence Line — counselling, safety & referrals" },
  { name: "Kids Helpline", num: "1800 55 1800", tel: "1800551800", note: "For young people aged 5–25" },
  { name: "Link2home", num: "1800 152 152", tel: "1800152152", note: "24/7 NSW homelessness and emergency accommodation line" },
];

export const CrisisLines = ({ dark }) => (
  <div data-testid="crisis-lines" className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
    {LINES.map((l) => (
      <a
        key={l.name}
        href={`tel:${l.tel}`}
        data-testid={`crisis-${l.name.toLowerCase()}`}
        className={`group flex flex-col justify-between rounded-2xl border p-6 transition-colors duration-300 ${dark ? "border-sand/20 hover:border-ochre" : "border-ink/15 bg-white/50 hover:border-ochre"}`}
      >
        <div>
          <p className="eyebrow text-ochre">{l.name}</p>
          <p className="mt-3 font-display text-3xl font-medium">{l.num}</p>
        </div>
        <p className={`mt-4 text-xs leading-relaxed ${dark ? "text-sand/80" : "text-ink/75"}`}>{l.note}</p>
        <span className="mt-4 flex items-center gap-2 text-xs font-semibold"><Phone className="h-3.5 w-3.5" /> Call now</span>
      </a>
    ))}
  </div>
);
